import { Modal, ModalFooter, ModalCloseButton, StyledButton, TextField, NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useForm } from 'src/common/form';
import { RoomSubmissionAction } from 'src/common/enums/rooms';
import { isQueryErrorWithMessage } from 'src/common/helpers/slices';
import { useUpdateSubmissionMutation } from '../../submissions.slice';
import { AddCommentModalProps, AddCommentProps } from './modal.types';
import { StyledModalDescription, StyledModalTitle } from './modal.styles';
export const AddCommentModal = ({
  roomCode,
  onClose,
  isOpen
}: AddCommentModalProps) => {
  const [updateSubmission] = useUpdateSubmissionMutation();
  const {
    register,
    reset,
    handleSubmit
  } = useForm<AddCommentProps>({
    mode: 'onSubmit'
  });
  const handleModalClose = () => {
    reset();
    onClose();
  };
  const onSubmit = async (data: AddCommentProps) => {
    try {
      const {
        comment
      } = data;
      await updateSubmission({
        comment,
        action: RoomSubmissionAction.COMMENT,
        date: 0,
        roomCode
      }).unwrap();
      NotificationDispatch('success', 'Comment added successfully');
    } catch (error) {
      NotificationDispatch('error', isQueryErrorWithMessage(error) ? error.data.message : 'An unknown error has occurred');
    }
    reset();
    handleModalClose();
    onClose();
  };
  return <Modal open={isOpen} onOpenChange={open => {
    if (!open) {
      handleModalClose();
    }
  }} data-sentry-element="Modal" data-sentry-component="AddCommentModal" data-sentry-source-file="add-comment-modal.tsx">
      <StyledModalTitle data-sentry-element="StyledModalTitle" data-sentry-source-file="add-comment-modal.tsx">Add Comment</StyledModalTitle>
      <StyledModalDescription data-sentry-element="StyledModalDescription" data-sentry-source-file="add-comment-modal.tsx">Comment</StyledModalDescription>
      {/* eslint-disable-next-line @typescript-eslint/no-misused-promises */}
      <form id="add-comment" method="dialog" onSubmit={handleSubmit(onSubmit)}>
        <TextField {...register('comment')} id="comment-id" placeholder="Type your comments in this space..." rows={4} variant="textarea" data-sentry-element="TextField" data-sentry-source-file="add-comment-modal.tsx" />
        <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="add-comment-modal.tsx">
          <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="add-comment-modal.tsx" />
          <StyledButton variant="solid" color="primary" type="submit" data-sentry-element="StyledButton" data-sentry-source-file="add-comment-modal.tsx">
            Add comment
          </StyledButton>
        </ModalFooter>
      </form>
    </Modal>;
};